import AvatarEditor, { clearImage } from 'react-avatar-editor';
import Hammer from 'react-hammerjs';
import EXIF from 'exif-js';
import Dropzone from 'react-dropzone';
import React from 'react';
import { connect } from 'react-redux';
import Txt from '../components/inputs/textInput.js';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
@connect(null, null, null, { forwardRef: true })
export default class PictureEditor extends React.Component {
  constructor(props) {
    super(props);
    this.imageDefaultValue = 1.0;
    this.minimumImageDroppedScale = this.props.minimumScaleImage || 1.0;
    this.maximumImageDroppedScale = 3.0;

    this.state = {
      imageDroppedScale: this.imageDefaultValue,
      imageEdited: '',
      isImageEditable: false,
      rotatePic: this.props.rotatePic,
      showAsDefaultImage: props.showAsDefaultImage,
      width: this.props.width,
      height: this.props.height,
      scrollScale: this.props.scrollScale,
    };
  }

  onDrop = (files) => {
    if (files.length > 0) {
      //added code so we dont throw exceptions when no images were dropped
      var that = this;
      EXIF.getData(files[0], function () {
        var orientation = EXIF.getTag(this, 'Orientation');
        let rotatePic = 0,
          height = that.state.height,
          width = that.state.width;
        switch (orientation) {
          case 8:
            rotatePic = 270;
            //The underlying library has a function isVertical(), which swaps height and width
            //if rotation % 180 !=0. To counter this we swap the height and width
            height = that.props.width;
            width = that.props.height;
            break;
          case 6:
            rotatePic = 90;
            height = that.props.width;
            width = that.props.height;
            break;
          case 3:
            rotatePic = 180;
            height = that.props.height;
            width = that.props.width;
            break;
          default:
            rotatePic = 0;
            height = that.props.height;
            width = that.props.width;
        }
        that.setState({
          rotatePic,
          imageEdited: files[0].preview,
          isImageEditable: true,
          isDefaultImage: false,
          height,
          width,
        });
      });
      $('input:file').val(''); //v.important so we can select the same image again
      if (this.props.autoFitToSize) {
        var img = new Image();
        img.src = files[0].preview;
        var that = this;
        img.onload = function () {
          var w = this.width;
          var h = this.height;

          if (this.width != this.height) {
            //checking the aspect ration. we scale down or up as per the aspect ration
            let dropScale = (this.height / this.width).toFixed(3) / 1;
            that.setState({ imageDroppedScale: dropScale });
          } else {
            that.setState({ imageDroppedScale: that.imageDefaultValue });
          }
        };
      }
      that.setState({ imageDroppedScale: that.imageDefaultValue });
    }
  };

  handleZoom = (evt) => {
    evt.preventDefault();
    if (evt.deltaY > 0) {
      //this means scroll down
      if (this.state.imageDroppedScale - this.state.scrollScale >= this.minimumImageDroppedScale)
        this.setState({ imageDroppedScale: this.state.imageDroppedScale - this.state.scrollScale });
    } else {
      //this means scroll up
      if (this.state.imageDroppedScale + this.state.scrollScale < this.maximumImageDroppedScale)
        this.setState({ imageDroppedScale: this.state.imageDroppedScale + this.state.scrollScale });
    }
  };

  getBase64 = () => {
    if (this.state.isImageEditable) {
      return this.refs.avatar.getImageScaledToCanvas().toDataURL();
    }
    return '';
  };

  getDefaultSelected() {
    return this.state.isDefaultImage;
  }

  handleUpload = () => {
    this.dropzone.fileInputEl.click();
    // this is only the event when u click 'upload', it does not mean u choosed file.
  };
  resetImageToDefault = () => {
    this.setState({
      rotatePic: 0,
      isDefaultImage: this.state.isDefaultImage || true,
      imageEdited: '',
      isImageEditable: false,
      imageDroppedScale: this.imageDefaultValue,
    });
  };
  onPinchOut = (e) => {
    if (this.state.imageDroppedScale + this.state.scrollScale < this.maximumImageDroppedScale) {
      this.setState({ imageDroppedScale: this.state.imageDroppedScale + this.state.scrollScale });
    }
  };
  onPinchIn = (e) => {
    if (this.state.imageDroppedScale - this.state.scrollScale >= this.minimumImageDroppedScale) {
      this.setState({ imageDroppedScale: this.state.imageDroppedScale - this.state.scrollScale });
    }
  };
  render() {
    const userMenuOptionTrigger = <i className="icon fl pdls camera" />;
    const itemClass = 'no-sub-menu';
    const supaDropdownUserMenuClassName = 'ui dropdown  item fr imageUpload';
    let userMenuOptions = [],
      resetImage = false;
    if (
      (this.state.isDefaultImage == true || !this.props.imageUrl) &&
      this.state.isImageEditable == false &&
      this.state.imageEdited.length == 0
    ) {
      resetImage = false;
    } else {
      resetImage = true;
    }

    userMenuOptions = [
      {
        text: APP.LANGUAGE.UploadImage,
        className: itemClass,
        onClick: this.handleUpload,
      },
      {
        text: APP.LANGUAGE.ResetImage,
        className: itemClass,
        onClick: () => this.resetImageToDefault(),
        className: resetImage ? 'item' : 'item disabled',
      },
    ];

    let resetClasses = ' ui button color-bad-things color-white  ';
    let previewClasses = ' ui button color-button color-button-hover color-white ';
    let uploadClasses = ' ui button color-button color-button-hover color-white  ';
    let imgStyles = {};
    var backgroundIfDefaultImage = '';
    if (
      (!this.props.imageUrl || this.state.isDefaultImage) &&
      !this.state.isImageEditable &&
      this.state.showAsDefaultImage &&
      this.props.applyDefaultImageStyle
    ) {
      imgStyles = { height: '65%', margin: '16%', marginLeft: '0%', marginright: '0%' };
      backgroundIfDefaultImage = 'color-gray-bg';
    }
    let options = {
      recognizers: {
        pinch: { enable: true },
      },
    };

    let imageDisplay = this.state.isImageEditable ? (
      <Hammer options={options} onPinchIn={this.onPinchIn} onPinchOut={this.onPinchOut}>
        <div>
          <AvatarEditor
            image={this.state.imageEdited}
            width={this.state.width}
            height={this.state.height}
            border={this.props.border || 20}
            ref="avatar"
            onDrop={this.onDrop}
            onSave={this.getBase64}
            onChange
            onMouseMove={() => {
              //the mouse events are handled in the parent Dropzone component
              event.stopPropagation();
              event.preventDefault();
            }}
            onMouseUp={() => {
              //the mouse events are handled in the parent Dropzone component
              event.stopPropagation();
              event.preventDefault();
            }}
            color={this.props.color} // RGBA
            scale={this.state.imageDroppedScale}
            rotate={this.state.rotatePic}
          />
        </div>
      </Hammer>
    ) : this.state.isDefaultImage ? (
      <img src={this.props.defaultImageUrl} style={imgStyles} />
    ) : (
      <img src={this.props.imageUrl || this.props.defaultImageUrl} style={imgStyles} />
    );
    let optionDropdown = (
      <Txt
        semanticui
        dropdown
        MenuClassName="imageUploadDropDown"
        trigger={userMenuOptionTrigger}
        className={supaDropdownUserMenuClassName}
        options={userMenuOptions}
      />
    );
    if (this.props.readOnly) {
      optionDropdown = '';
    } else if (!this.props.displayUploadOptions) {
      optionDropdown = (
        <button icon="camera" className="ui button fr buttonImageUpload" onClick={this.handleUpload}>
          <Icon name="camera" className="camera-icon-under-btn" />
        </button>
      );
    }

    return (
      <div
        className={
          this.props.fourByThreeRatio
            ? 'fourByThreeRatio pictureEditorMain'
            : this.props.pictureEditorClass || 'pictureEditorMain'
        }
      >
        <Dropzone
          disableClick={true}
          ref={(dropzone) => (this.dropzone = dropzone)}
          onDrop={this.onDrop}
          className="drop-zone pointer pdtnull"
          accept="image/*"
        >
          <div className={'canvas-holder ' + backgroundIfDefaultImage} onWheel={this.handleZoom}>
            {optionDropdown}
            {imageDisplay}
          </div>
        </Dropzone>
      </div>
    );
  }
}
PictureEditor.defaultProps = {
  showAsDefaultImage: true,
  displayUploadOptions: true,
  minimumScaleImage: 1.0,
  readOnly: false,
  width: 640,
  height: 640,
  scrollScale: 0.025,
  rotatePic: 0,
  color: [255, 255, 255, 0.7],
  applyDefaultImageStyle: true,
};
PictureEditor.propTypes = {
  displayUploadOptions: PropTypes.bool, //boolean property to show the image upload reset options. Default it will sow
  rotatePic: PropTypes.number, //optional, if we want to rotate the pic
  imageUrl: PropTypes.string, // Image to display
  minimumScaleImage: PropTypes.number, //if you want to zoom out below 1.0 set the value
  border: PropTypes.number, //Gray border of the picture,
  readOnly: PropTypes.bool, //by default false. if true upload, reset and camera not displayed,
  width: PropTypes.number,
  height: PropTypes.number,
  autoFitToSize: PropTypes.bool, //if we want to scale down everything to fit itself
  showAsDefaultImage: PropTypes.bool, //if yes, then we will show the borders around. if false then the default image is fit
  defaultImageUrl: PropTypes.string, //default image url is set when you reset image
  fourByThreeRatio: PropTypes.bool, //this sets the special styling for rectangle, by default it is square ,
  scrollScale: PropTypes.number, //Scale interval of zoom in and out
  pictureEditorClass: PropTypes.string, //Optional class if you dont want to use any of they default classes
  color: PropTypes.object, //color of the border
  applyDefaultImageStyle: PropTypes.bool, //this basically informs us if we want to apply the compression of 65% when we display the default image
};
